"use client";

import { createContext, useContext, useState, useEffect } from "react";
import { getGtmConfig } from "@package/api/config/gtmConfig";

const GtmContext = createContext({
  gtmEnabled: false,
  setGtmEnabled: () => {},
  isGtmInitialized: false,
  companyDetails: null,
});

export const GtmProvider = ({ children, companyDetails = null }) => {
  const [gtmEnabled, setGtmEnabled] = useState(false);
  const [isGtmInitialized, setIsGtmInitialized] = useState(false);

  useEffect(() => {
    const fetchGtmConfig = async () => {
      try {
        const data = getGtmConfig();
        setGtmEnabled(data.gtmEnabled || false);
      } catch (error) {
        console.error("Failed to fetch GTM config:", error);
        setGtmEnabled(false);
      } finally {
        setIsGtmInitialized(true);
      }
    };

    fetchGtmConfig();
  }, []);

  return (
    <GtmContext.Provider
      value={{ gtmEnabled, setGtmEnabled, isGtmInitialized, companyDetails }}
    >
      {children}
    </GtmContext.Provider>
  );
};

export const useGtm = () => {
  const context = useContext(GtmContext);
  if (!context) {
    throw new Error("useGtm must be used within GtmProvider");
  }
  return context;
};
